import { CartLinesUpdateEvent } from '@shopify/events';

class CartUpsell extends HTMLElement {
  static busy = false;
  connectedCallback() { this.addEventListener('click', this.add); }
  disconnectedCallback() { this.removeEventListener('click', this.add); }
  add = async (event) => {
    const button = event.target.closest('button[data-variant-id]');
    if (!button || !this.contains(button) || CartUpsell.busy) return;
    CartUpsell.busy = true;
    const status = this.querySelector('[role="status"]');
    const recovery = this.querySelector('.erten-cart-upsell__recovery');
    const label = button.textContent;
    document.querySelectorAll('erten-cart-upsell button').forEach(item => { item.disabled = true; });
    button.textContent = this.dataset.adding;
    status.textContent = '';
    recovery.hidden = true;
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'cart',lines:[{merchandiseId:button.dataset.variantId,quantity:1}],promise:deferred.promise}));
    let added = false;
    try {
      const beforeResponse = await fetch(this.dataset.cartUrl, {cache:'no-store'});
      if (!beforeResponse.ok) throw new Error();
      const before = await beforeResponse.json();
      if (before.item_count !== 1 || before.items[0]?.key !== this.dataset.sourceKey) {
        status.textContent = this.dataset.changed;
        deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(before),detail:{didError:true}});
        return;
      }
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0,5);
      const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}],sections,sections_url:window.location.pathname})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error();
      added = true;
      const cartResponse = await fetch(this.dataset.cartUrl, {cache:'no-store'});
      if (!cartResponse.ok) throw new Error();
      const cart = await cartResponse.json();
      status.textContent = this.dataset.added;
      const origin = this.closest('cart-items-component');
      const focusTarget = origin?.querySelector('.cart__checkout-button, button[name="checkout"], #checkout');
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:result.sections,source:'erten-cart-upsell',didError:false}});
      requestAnimationFrame(() => { if (focusTarget?.isConnected) focusTarget.focus({preventScroll:true}); });
    } catch {
      status.textContent = added ? this.dataset.refresh : this.dataset.error;
      recovery.hidden = !added;
      deferred.resolve({detail:{didError:true}});
    } finally {
      CartUpsell.busy = false;
      if (!added) document.querySelectorAll('erten-cart-upsell button').forEach(item => { item.disabled = false; });
      if (button.isConnected && !added) button.textContent = label;
    }
  };
}
if (!customElements.get('erten-cart-upsell')) customElements.define('erten-cart-upsell', CartUpsell);
